import { MOVEMENT_TYPES, ServerAccountType } from '@expane/data'
import { useAccountsWithoutCheckbox } from '@expane/logic/payment/checkbox'
import { NumberInput, SelectDropdown } from '@expane/ui'
import { FC } from 'react'
import { Control, Controller } from 'react-hook-form'
import { MovementInfoDialogFormValues } from './'
import { checkWithdrawPossibility } from '@expane/logic/form'
import { getCurrentAccount } from '@expane/logic/accounts'
import { showAccountErrorMessage } from 'logic/form'
import { useTranslation } from 'react-i18next'

export const PaymentBlock: FC<{
  movementType: number
  control: Control<MovementInfoDialogFormValues>
  accounts: ServerAccountType[] | undefined
  priceToPay: number
}> = ({ movementType, control, accounts, priceToPay }) => {
  const { accountsWithoutCheckbox } = useAccountsWithoutCheckbox(accounts ?? [])

  const { t } = useTranslation()

  return (
    <div className="flex justify-end">
      <Controller
        control={control}
        name="accountId"
        rules={{
          required: true,
          validate: {
            checkWithdrawPossibility: value =>
              checkWithdrawPossibility({
                currentAccount: getCurrentAccount(accounts, value),
                value: Number(priceToPay),
              }),
          },
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <SelectDropdown
            className="w-52"
            label={movementType === MOVEMENT_TYPES.arrival.id ? t('fromAccount') : t('toAccount')}
            required
            items={accountsWithoutCheckbox}
            onSelectChange={onChange}
            value={value}
            errorMessage={{
              isShown: Boolean(error),
              text: showAccountErrorMessage(error?.type ?? '', t),
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="amount"
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <NumberInput
            required
            value={value}
            onChange={onChange}
            containerClassName="w-36 ml-2"
            label={t('amount')}
            errorMessage={{
              isShown: Boolean(error),
              text: t('formError.required'),
            }}
          />
        )}
      />
    </div>
  )
}
